module.exports = __webpack_public_path__ + "img/christopher-campbell-rDEOVtE7vOs-unsplash.24d5081a.jpg";